interface ICommonLinkButton extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  text: string;
  link: string;
  icon?: string;
}

/** External link CTA — PNG icons use invert (asset is dark circle + transparent glyph) */
export const CommonLinkButton: React.FC<ICommonLinkButton> = ({
  text,
  link,
  icon,
  className = "",
  ...props
}) => {
  const assets = import.meta.env.VITE_S3_ASSET_URL;

  return (
    <a
      href={link}
      className={`common-link-button inline-flex w-fit cursor-pointer items-center gap-fh-medium rounded-round border border-transparent bg-white/10 px-4 py-[0.7rem] font-shentox text-[clamp(1rem,1vw,1rem)] font-[200] leading-4 tracking-[0.02rem] text-white no-underline transition-[background-color,transform,color] duration-[0.3s,0.2s,0.2s] ease-[ease] hover:scale-95 hover:text-light-blue active:translate-y-0 ${className}`}
      {...props}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
      {icon ? (
        <img
          src={`${assets}/${icon}`}
          alt=""
          width={24}
          height={24}
          loading="lazy"
          decoding="async"
          className="common-link-button__icon ml-auto h-6 w-6 shrink-0 border-0 object-contain p-0"
        />
      ) : null}
    </a>
  );
};
